import { useEffect, useState } from "react";
import { Users, Trophy } from "lucide-react";
import api from "../lib/api";
import { SectionCard, Stamp } from "./kit";
import { titleCase } from "../lib/constants";

export default function TeamActivity() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/property-data/team-activity").then(({ data }) => setD(data)).catch(() => setD({ users: [], total_actions: 0 })); }, []);
  return (
    <SectionCard title="Who Did What Today" testid="team-activity" action={d && <span className="text-xs text-slate-400">{d.total_actions} actions · {d.logins_today} sign-ins</span>}>
      {!d ? <p className="text-sm text-slate-400">Loading…</p> : d.users.length === 0 ? (
        <p className="text-sm text-slate-400 py-4 text-center">No team activity yet today — be the first to make a move.</p>
      ) : (
        <div className="space-y-3 max-h-[300px] overflow-y-auto pr-1">
          {d.users.map((u, i) => (
            <div key={u.user_id || i} className="rounded-lg border border-slate-100 p-3" data-testid={`team-activity-${u.user_id || i}`}>
              <div className="flex items-center gap-2.5">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${i === 0 ? "bg-gold text-navy-900" : "bg-navy-800 text-gold"}`}>{i === 0 ? <Trophy className="w-4 h-4" /> : (u.user_name || "?")[0]}</div>
                <div className="flex-1 min-w-0"><p className="text-sm font-semibold text-navy-800 truncate">{u.user_name}</p>
                  <p className="text-[11px] text-slate-400 truncate">{Object.entries(u.actions).slice(0, 4).map(([a, n]) => `${n} ${titleCase(a).toLowerCase()}`).join(" · ")}</p></div>
                <span className="font-display font-bold text-navy-800">{u.total}</span>
              </div>
              <div className="mt-2 space-y-1">
                {u.latest.map((l, j) => (
                  <div key={j} className="flex items-center gap-2 text-xs text-slate-500"><Users className="w-3 h-3 text-slate-300 shrink-0" />
                    <span className="truncate flex-1">{titleCase(l.action)} {titleCase((l.record_type || "").replace(/s$/, "")).toLowerCase()}{l.name ? ` · ${l.name}` : ""}</span>
                    <Stamp at={l.timestamp} /></div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </SectionCard>
  );
}
